import { get } from 'lodash';
import { OVERRIDE_GROUPING_ENDPOINT } from '../../../../../../../common/config/api_endpoints';
import {
  createAPILifecycleActions,
  createAPILifecycleActionTypes,
} from '../../../../../../../redux/actions/action_utils';
import createAmplifyAPICallEpic from '../../../../../../../redux/epics/utils';
import { configureRefreshStateAction } from '../../../../../../../common/redux/configureRefreshState';
import { UPDATE_GROUPING_DATA_REFRESH_DELAY_TIME_IN_MS } from '../../../../../../../common/components/table/constants';

export const OVERRIDE_LABOR_GROUPING_ACTION_TYPES = createAPILifecycleActionTypes(
  'OVERRIDE_GROUPING_ACTION_TYPES',
);
export const overrideLaborGroupingAction = createAPILifecycleActions(
  OVERRIDE_LABOR_GROUPING_ACTION_TYPES.NAME,
);

const initialState = {
  isFetching: false,
  data: null,
  error: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case OVERRIDE_LABOR_GROUPING_ACTION_TYPES.BEGIN:
      return {
        ...state,
        isFetching: true,
      };
    case OVERRIDE_LABOR_GROUPING_ACTION_TYPES.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: {
          groupingId: get(payload, 'groupingId'),
          status: get(payload, 'status'),
        },
        error: null,
      };
    case OVERRIDE_LABOR_GROUPING_ACTION_TYPES.FAILURE:
      return {
        ...state,
        isFetching: false,
        data: null,
        error: payload,
      };

    case OVERRIDE_LABOR_GROUPING_ACTION_TYPES.CLEAR:
      return initialState;
    default:
      return state;
  }
};

export const overrideLaborGroupingEpic = createAmplifyAPICallEpic({
  actionType: OVERRIDE_LABOR_GROUPING_ACTION_TYPES.BEGIN,
  api: OVERRIDE_GROUPING_ENDPOINT,
  successCallback: response => [
    overrideLaborGroupingAction.SUCCESS(response),
    configureRefreshStateAction.BEGIN(UPDATE_GROUPING_DATA_REFRESH_DELAY_TIME_IN_MS),
  ],
  errorCallback: () => [overrideLaborGroupingAction.FAILURE()],
});
